import { css } from '@emotion/react';

export const textStyle = css`
  max-width: 600px;
`;
